<template>
    <div class="demand">
        <!-- 需求 -->
        <div v-if="wishBtn" class="orderContent" @click="toAddwish">
            <i class="iconfont icon-tubiao09"></i>
            <p>心愿</p>
        </div>
        <!-- 活动 -->
        <activeData />
    </div>
</template>

<script>
import activeData from './active'
export default {
    data() {
        return {
            wishBtn: true,
        }
    },
    components:{
        activeData
    },
    created() {
      if(window.localStorage.oldWishToken&&window.localStorage.oldenterpriseInfo){
        window.localStorage.userinfo = window.localStorage.oldWishToken;
        window.localStorage.enterpriseInfo = window.localStorage.oldenterpriseInfo;
      }
      
      // 只有会员可以发布心愿
      if(window.localStorage.enterpriseInfo&&window.localStorage.enterpriseInfo!='undefined'){ // 爱心企业登入
        this.wishBtn = false;
      } else if(window.localStorage.personalInformation&&window.localStorage.personalInformation!='undefined'){  // 会员登入
        this.wishBtn = true;
      } else{ // 都没登入
        this.wishBtn = false;
      }

      window['toLeave'] = () => { //安卓给数据
        // alert('123')
        if(window.localStorage.enterpriseInfo&&window.localStorage.enterpriseInfo!='undefined'){ // 爱心企业登入
          window.localStorage.oldWishToken = window.localStorage.userinfo;
          window.localStorage.oldenterpriseInfo = window.localStorage.enterpriseInfo;
          // 企业信息清空
          window.localStorage.userinfo = '';
          window.localStorage.enterpriseInfo='';  
        }
      };

      // ios登入 地理位置
      this.setupWebViewJavascriptBridge(function(bridge){
          bridge.registerHandler("toLeave", function(){
            if(window.localStorage.enterpriseInfo&&window.localStorage.enterpriseInfo!='undefined'){ // 爱心企业登入
              window.localStorage.oldWishToken = window.localStorage.userinfo;
              window.localStorage.oldenterpriseInfo = window.localStorage.enterpriseInfo;
              // 企业信息清空
              window.localStorage.userinfo = '';
              window.localStorage.enterpriseInfo='';  
            }
          });
      });
    },
    methods:{
      toAddwish(){
        // $router.push('/wishList')
        var link=window.location.href.split("#/")[0]+"#/wishList"; //心愿页面
        this.linkPhone({url: link,title:'发布心愿'});
      }
    }
}
</script>

<style lang="less" scoped>
.demand{
    position: relative;
    .orderContent{
        position: fixed;
        bottom: 20vw;
        right: 5vw;
        width: 50px;
        height: 50px;
        border-radius: 100%;
        color: #fff;
        background: rgba(221, 40, 40, 0.8);
        display: flex;
        justify-content: center;
        align-content: center;
        flex-wrap: wrap;
        z-index: 9999;
        p{
            width: 100%;
            text-align: center;
        }
    }
}
</style>